import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                        <div className="consider_content">
                                <h2>When to Consider Our Intellectual Property Protection</h2>
                               <p>Investing in intellectual property protection is a strategic decision that can secure the core assets of your business. In today's competitive landscape, where innovation is key, protecting your intellectual property is crucial for business sustainability. Here's why you should consider our services:</p> 
                               <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let Us Protect Your IP</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <div className="consider-box">
                        <h6>Innovation Safeguarding</h6>
                        <p>Ensure the security of your innovative ideas and products by leveraging our intellectual property protection services to foster continuous creativity.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Global Expansion Support</h6>
                        <p>Our services extend across multiple countries, regions, and territories, providing comprehensive coverage to support your international ventures.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Legal Dispute Resolution</h6>
                        <p>With our expertise, you gain a valuable ally in resolving disputes efficiently through out-of-court settlements, enabling you to focus on your business.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Considerapp